class HeaderSticky {
  constructor() {
    this.header = document.getElementById('header')
    this.topBar = document.getElementById('top-bar')
    this.placeholder = null
    this.lastScrollTop = 0
    this.isFixed = false
    this.showThreshold = 0
    this.hideThreshold = 0

    this.disabledRoutes = ['/collections', '/search']

    this.init()
  }

  init() {
    if (!this.header || !this.topBar) return

    if (!this.isStickyAllowedOnCurrentPage()) {
      return
    }

    this.createPlaceholder()
    this.updateThresholds()
    this.attachEventListeners()
  }

  isStickyAllowedOnCurrentPage() {
    const currentPath = window.location.pathname

    for (let route of this.disabledRoutes) {
      if (currentPath.startsWith(route)) {
        return false
      }
    }

    return true
  }

  createPlaceholder() {
    this.placeholder = document.createElement('div')
    this.placeholder.id = 'header-placeholder'
    this.placeholder.style.display = 'none'
    this.header.parentNode.insertBefore(this.placeholder, this.header.nextSibling)
  }

  updateThresholds() {
    this.showThreshold = this.topBar.offsetHeight + this.header.offsetHeight
    this.hideThreshold = this.topBar.offsetHeight
    this.placeholder.style.height = this.header.offsetHeight + 'px'
  }

  attachEventListeners() {
    window.addEventListener('load', () => this.updateThresholds())
    window.addEventListener('resize', () => this.updateThresholds())

    document.addEventListener('scroll', () => this.handleScroll())
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (scrollTop > this.showThreshold) {
      if (scrollTop < this.lastScrollTop) {
        if (!this.isFixed) {
          this.fixHeader()
        }
      } else if (scrollTop > this.lastScrollTop) {
        if (this.isFixed) {
          this.unfixHeader()
        }
      }
    } else if (scrollTop <= this.hideThreshold) {
      if (this.isFixed) {
        this.resetHeader()
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
  }

  fixHeader() {
    this.updateThresholds()
    this.placeholder.style.display = 'block'

    this.header.style.position = 'fixed'
    this.header.style.top = '0'
    this.header.style.left = '0'
    this.header.style.right = '0'
    this.header.style.zIndex = '50'
    this.header.style.animation = 'slideDown 0.4s ease-out forwards'

    this.isFixed = true
  }

  unfixHeader() {
    this.header.style.animation = 'slideUp 0.4s ease-out forwards'

    setTimeout(() => {
      this.resetHeader()
    }, 400)
  }

  resetHeader() {
    this.placeholder.style.display = 'none'
    this.header.style.position = 'relative'
    this.header.style.top = ''
    this.header.style.left = ''
    this.header.style.right = ''
    this.header.style.animation = 'none'
    this.isFixed = false
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.headerStickyInstance = new HeaderSticky()
})
